import { render, staticRenderFns } from "./LegalForm.vue?vue&type=template&id=5437855f&"
import script from "./LegalForm.vue?vue&type=script&lang=js&"
export * from "./LegalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports